var mutations = {};
export default mutations;